import { Close } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "@mui/lab";
import {
  Autocomplete,
  Button,
  FormControl,
  Grid,
  IconButton,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import {
  FETCH_CLIENT_EMP_JOBS,
  SAVE_CLIENT_SITE_ESTIMATES_ENTRIES,
  SAVE_CLIENT_SITE_ESTIMATIONS
} from "../../constant/Apipath";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import { BILightGrey } from "../../assets/helpers";

export default function ClientEstimateAddModal({ isOpen, onClose, reLoadData }) {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const userId = loginData?.userInformation?.UserId;
  const CLIENT_ACCENT_COLOR = selectedClientData?.AccentColor;
  const TOKEN = loginData?.accessToken;
  const [jobOptions, setJobOptions] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState({
    jobCodeId: "",
    items: [{ description: "", days: "", employees: "" }]
  });
  const [isLoading, setIsLoading] = useState(false);
  const inputRefs = useRef([]);

  const LANGUAGE = ClientEnglishFallback.ClientEstimateAddModal(
    multiLanguageData?.ClientEstimateAddModal || {}
  );
  const {
    TEXT_DESCRIPTION,
    TEXT_DAYS,
    TEXT_EMPLOYEES,
    TEXT_SUB_TOTAL,
    TEXT_SUBMIT,
    TEXT_JOB,
    TEXT_PLACEHOLDER_SEARCH_JOB,
    TEXT_NO_JOB,
    TEXT_JOBS,
    TEXT_AREA_ITEM,
    TEXT_ADD_ITEM,
    TEXT_CREATE_ESTIMATE
  } = LANGUAGE;

  const getJobList = async () => {
    try {
      const obj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: userId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            clientEmployeeId: Number(selectedClientData?.ClientEmployeeId),
            clientId: selectedClientData?.ClientId,
            active: true
          }
        ]
      };

      const res = await Postrequestcall(FETCH_CLIENT_EMP_JOBS, obj, TOKEN);
      setJobOptions(res.data?.data);
    } catch (err) {
      console.log("getJobList-> Error Getting Client Employee Jobs: ", err);
    }
  };

  const handleAddItem = () => {
    setData({
      ...data,
      items: [...data.items, { description: "", days: "", employees: "" }]
    });
  };

  const handleRemoveItem = (index) => {
    const items = data.items.filter((_, i) => i !== index);
    setData({ ...data, items });
  };

  const handleChangeItem = (index, field, value) => {
    const items = data.items?.map((item, i) => (i === index ? { ...item, [field]: value } : item));
    setData({ ...data, items });
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    const clientEmployeeId = selectedClientData?.ClientEmployeeId;
    const payload = {
      UserId: userId,
      ReturnRecordId: true,
      ReturnRecordError: true,
      SaveList: [
        {
          Id: 0,
          ClientEmployeeId: clientEmployeeId,
          ClientJobId: selectedJob?.id,
          EstimationDate: "",
          ModifiedBy: Number(userId)
        }
      ]
    };

    try {
      const response = await Postrequestcall(SAVE_CLIENT_SITE_ESTIMATIONS, payload, TOKEN);
      const objData = response?.data?.data[0]?.objData;
      const modifiedSaveList = data?.items?.map((item) => ({
        Id: 0,
        ClientSiteEstimationId: objData?.id,
        Description: item?.description,
        Days: Number(item?.days).toFixed(2),
        Employees: Number(item?.employees),
        SubTotal: Number((Number(item?.employees) * Number(item?.days)).toFixed(2)),
        ModifiedBy: Number(userId)
      }));

      const entriesPayload = {
        UserId: userId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: modifiedSaveList
      };

      await Postrequestcall(SAVE_CLIENT_SITE_ESTIMATES_ENTRIES, entriesPayload, TOKEN);
      setIsLoading(false);
      reLoadData();
      onClose();
    } catch (err) {
      setIsLoading(false);
      console.log("handleSubmit-> Error Saving Client Site Estimations: ", err);
    } finally {
      handleClose();
    }
  };

  useEffect(() => {
    getJobList();
  }, []);

  useEffect(() => {
    if (data.items?.length > 0) {
      inputRefs.current[data?.items?.length - 1]?.focus();
    }
  }, [data.items]);

  const isSubmitDisabled =
    !data.jobCodeId ||
    data.items.some((item) => !item.description || !item.days || !item.employees);

  const handleClose = () => {
    onClose();
    setData({
      jobCodeId: "",
      items: [{ description: "", days: "", employees: "" }]
    });
  };

  return (
    <>
      <Modal open={isOpen} onClose={onClose}>
        <div
          className="client-modal-responsive"
          style={{
            padding: "10px 10px 10px 10px"
          }}>
          <Stack justifyContent={"space-between"} flexDirection={"row"} alignItems={"center"}>
            <Typography variant="p">{TEXT_CREATE_ESTIMATE}</Typography>
            <IconButton
              onClick={() => onClose()}
              sx={{
                color:
                  selectedClientData?.AccentColor !== undefined && selectedClientData?.AccentColor
                    ? selectedClientData?.AccentColor
                    : BILightGrey
              }}>
              <CloseIcon />
            </IconButton>
          </Stack>

          <FormControl fullWidth>
            <Autocomplete
              sx={{
                backgroundColor: "#e4e4e4",
                borderRadius: "10px",
                "& fieldset": { border: "none" }
              }}
              size="small"
              style={{
                backgroundColor: "#f2f2f2",
                borderRadius: "10px"
              }}
              options={jobOptions}
              value={selectedJob}
              inputValue={searchTerm}
              getOptionLabel={(option) => `${option?.jobCode + " - " + option?.name}`}
              onInputChange={(_, value, reason) => {
                if (reason === "input") {
                  let inputValue = value.replace(/^[^A-Za-z0-9]+/, "");
                  setSearchTerm(inputValue);
                }
              }}
              onChange={(event, newValue) => {
                if (newValue) {
                  setData({ ...data, jobCodeId: newValue?.id || "" });
                  setSelectedJob(newValue);
                  setSearchTerm(newValue?.jobCode + " - " + newValue?.name);
                } else {
                  setSelectedJob(null);
                  setData({ ...data, jobCodeId: "" });
                  setSearchTerm("");
                }
              }}
              renderInput={(params) => {
                return (
                  <TextField
                    placeholder={TEXT_PLACEHOLDER_SEARCH_JOB}
                    {...params}
                    variant="outlined"
                  />
                );
              }}
            />
          </FormControl>

          {data?.items?.length === 0 ? (
            <Button
              onClick={handleAddItem}
              fullWidth
              size="small"
              sx={{
                mt: 1,
                textTransform: "none",
                borderRadius: "10px",
                color: "white",
                backgroundColor: CLIENT_ACCENT_COLOR
              }}>
              {TEXT_ADD_ITEM}
            </Button>
          ) : (
            <>
              <Stack
                display={"flex"}
                justifyContent={"space-between"}
                flexDirection={"row"}
                alignItems={"center"}>
                <h4>{TEXT_AREA_ITEM}</h4>
                <Typography
                  style={{
                    textTransform: "none",
                    color: CLIENT_ACCENT_COLOR,
                    cursor: "pointer"
                  }}
                  onClick={handleAddItem}>
                  {TEXT_ADD_ITEM}
                </Typography>
              </Stack>

              <>
                <div
                  style={{
                    maxHeight: "300px",
                    overflowY: "auto",
                    scrollbarWidth: "none"
                  }}>
                  {data?.items?.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        padding: "10px",
                        borderRadius: "10px",
                        border: "1px solid #e4e4e4",
                        marginBottom: "10px"
                      }}>
                      <Stack display={"flex"} flexDirection={"row"}>
                        {" "}
                        <TextField
                          size={"small"}
                          style={{
                            backgroundColor: "#f2f2f2",
                            borderRadius: "10px"
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "0",
                              padding: "0"
                            },
                            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                              border: "none"
                            }
                          }}
                          placeholder={TEXT_DESCRIPTION}
                          value={item.description}
                          onChange={(e) => {
                            let inputValue = e.target.value;
                            inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                            handleChangeItem(index, "description", inputValue);
                          }}
                          fullWidth
                        // inputRef={(el) => (inputRefs.current[index] = el)}
                        />
                        <IconButton onClick={() => handleRemoveItem(index)}>
                          <Close
                            sx={{
                              color:
                                selectedClientData?.AccentColor !== undefined && selectedClientData?.AccentColor
                                  ? selectedClientData?.AccentColor
                                  : BILightGrey
                            }}
                          />
                        </IconButton>
                      </Stack>

                      <Grid spacing={1} container mt={1}>
                        <Grid size={4.5}>
                          <Stack>
                            <Typography>{TEXT_DAYS}</Typography>
                            <TextField
                              placeholder="0.00"
                              size={"small"}
                              style={{
                                backgroundColor: "#f2f2f2",
                                borderRadius: "10px"
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "0",
                                  padding: "0"
                                },
                                "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                                  border: "none"
                                }
                              }}
                              type="text"
                              value={item?.days}
                              onChange={(e) => {
                                const value = e.target.value;
                                // Regex to allow up to two decimal places
                                const regex = /^\d{0,4}(\.\d{0,2})?$/;
                                // Check if the input matches the regex
                                if (regex.test(value)) {
                                  handleChangeItem(index, "days", value);
                                }
                              }}
                              inputProps={{ step: 0.01 }}
                            />
                          </Stack>
                        </Grid>
                        <Grid size={4.5}>
                          <Stack>
                            <Typography>{TEXT_EMPLOYEES}</Typography>
                            <TextField
                              placeholder="0"
                              size={"small"}
                              style={{
                                backgroundColor: "#f2f2f2",
                                borderRadius: "10px"
                              }}
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "0",
                                  padding: "0"
                                },
                                "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                                  border: "none"
                                }
                              }}
                              type="text"
                              value={item.employees}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value === "") {
                                  handleChangeItem(index, "employees", parseInt(0));
                                } else {
                                  const regex = /^\d{0,4}(\.\d{0,2})?$/;
                                  if (regex.test(value)) {
                                    handleChangeItem(index, "employees", parseInt(e.target.value));
                                  }
                                }
                              }}
                            />
                          </Stack>
                        </Grid>
                        <Grid size={3}>
                          <Stack>
                            <Typography>{TEXT_SUB_TOTAL}</Typography>
                            <Typography
                              align="center"
                              style={{
                                padding: "6px",
                                fontWeight: "bold",
                                color: CLIENT_ACCENT_COLOR
                              }}>
                              {(item.days * item.employees).toFixed(2) || 0}
                            </Typography>
                          </Stack>
                        </Grid>
                      </Grid>
                    </div>
                  ))}
                </div>
              </>
            </>
          )}

          <LoadingButton
            size="small"
            onClick={handleSubmit}
            disabled={isSubmitDisabled || data.items?.length === 0}
            loading={isLoading}
            loadingPosition="start"
            startIcon={<></>}
            fullWidth
            style={{
              marginTop: "10px",
              textTransform: "none",
              backgroundColor:
                isSubmitDisabled || data.items?.length === 0 ? "lightgrey" : CLIENT_ACCENT_COLOR,
              color: "white",
              borderRadius: "10px"
            }}>
            {TEXT_SUBMIT}
          </LoadingButton>
        </div>
      </Modal>
    </>
  );
}
